export const PWA_TIP_DISMISSED_KEY = 'tlk_pwa_tip_dismissed';
export const SPLASH_SHOWN_KEY = 'tlk_splash_shown';

export function isPwaInstalled() {
  if (typeof window === 'undefined') return false;
  return (
    window.matchMedia('(display-mode: standalone)').matches
    || window.matchMedia('(display-mode: fullscreen)').matches
    || window.matchMedia('(display-mode: minimal-ui)').matches
    || window.navigator.standalone === true
  );
}

function dismissedKey(userId) {
  return userId ? `${PWA_TIP_DISMISSED_KEY}:${userId}` : PWA_TIP_DISMISSED_KEY;
}

export function isPwaTipDismissed(userId) {
  if (typeof window === 'undefined' || !userId) return false;
  return localStorage.getItem(dismissedKey(userId)) === '1';
}

export function dismissPwaTip(userId) {
  if (typeof window === 'undefined') return;
  localStorage.setItem(dismissedKey(userId), '1');
}

// Splash "already shown" is tracked PER USER. The server flag
// (user.splash_video_shown) is the source of truth; this local key is only a
// fallback so a returning user on the same browser/PWA doesn't replay splash if
// the server flag write was slow or lost. It must never be global, otherwise one
// account watching splash would suppress it for every other account on the device.
function splashKey(userId) {
  return `${SPLASH_SHOWN_KEY}:${userId}`;
}

export function isSplashShownLocally(userId) {
  if (typeof window === 'undefined' || !userId) return false;
  return localStorage.getItem(splashKey(userId)) === '1';
}

export function markSplashShownLocally(userId) {
  if (typeof window === 'undefined' || !userId) return;
  localStorage.setItem(splashKey(userId), '1');
}

export function getInstallPlatform() {
  if (typeof navigator === 'undefined') return 'other';
  const ua = navigator.userAgent;
  if (/iPad|iPhone|iPod/.test(ua)) return 'ios';
  if (/Android/.test(ua)) return 'android';
  return 'other';
}
